import React from 'react';
import Skeleton from './Skeleton';
import './LoadingFallback.css';

/**
 * Loading Fallback Component
 * Used for lazy-loaded routes during code splitting
 * Enhanced with a comprehensive skeleton that mimics the landing page layout
 */
const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-fallback">
      {/* Header Skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-header-content">
          <Skeleton width="120px" height="40px" style={{ borderRadius: '8px' }} />
          <div className="skeleton-header-nav">
            <Skeleton width="60px" height="20px" />
            <Skeleton width="60px" height="20px" />
            <Skeleton width="60px" height="20px" />
            <Skeleton width="60px" height="20px" />
          </div>
          <div className="skeleton-header-actions">
            <Skeleton width="24px" height="24px" circle />
            <Skeleton width="24px" height="24px" circle />
            <Skeleton width="80px" height="36px" style={{ borderRadius: '20px' }} />
          </div>
        </div>
      </div>

      {/* Banner Skeleton */}
      <div className="skeleton-banner">
        <Skeleton width="100%" height="400px" style={{ borderRadius: '0' }} />
        <div className="skeleton-banner-overlay">
          <Skeleton width="200px" height="48px" style={{ borderRadius: '24px', margin: '0 auto' }} />
        </div>
      </div>

      {/* Category Cards Skeleton */}
      <div className="skeleton-categories">
        <div className="skeleton-category-card">
          <Skeleton width="100%" height="200px" style={{ borderRadius: '12px', marginBottom: '1rem' }} />
          <Skeleton width="70%" height="24px" style={{ marginBottom: '0.5rem' }} />
          <Skeleton width="50%" height="16px" />
        </div>
        <div className="skeleton-category-card">
          <Skeleton width="100%" height="200px" style={{ borderRadius: '12px', marginBottom: '1rem' }} />
          <Skeleton width="70%" height="24px" style={{ marginBottom: '0.5rem' }} />
          <Skeleton width="50%" height="16px" />
        </div>
      </div>

      {/* Product Section Skeleton */}
      <div className="skeleton-products-section">
        <div className="skeleton-section-header">
          <Skeleton width="250px" height="32px" style={{ marginBottom: '0.5rem' }} />
          <Skeleton width="300px" height="16px" />
        </div>
        <div className="skeleton-products-grid">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="skeleton-product-card">
              <Skeleton width="100%" height="200px" style={{ borderRadius: '12px', marginBottom: '1rem' }} />
              <Skeleton width="80%" height="20px" style={{ marginBottom: '0.5rem' }} />
              <Skeleton width="60%" height="18px" style={{ marginBottom: '0.5rem' }} />
              <div className="skeleton-product-footer">
                <Skeleton width="100px" height="24px" />
                <Skeleton width="80px" height="36px" style={{ borderRadius: '18px' }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Loading Indicator */}
      <div className="loading-indicator">
        <div className="loading-spinner"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingFallback;

